// Parses the spotlight query text.
// V1: every token is a plain term. Tokens shaped like `field:value` are
// recognized and routed to `filters` so attribute filters (pk:, type:, …)
// can ship later without reparsing — the engine decides what to do with them.
export function parseQuery(text) {
    const tokens = String(text ?? '')
        .trim()
        .toLowerCase()
        .split(/\s+/)
        .filter(Boolean);

    const terms = [];
    const filters = [];
    for (const token of tokens) {
        const match = token.match(/^([a-z_]+):(.*)$/);
        if (match) {
            filters.push({ field: match[1], value: match[2], raw: token });
        } else {
            terms.push(token);
        }
    }
    return { terms, filters };
}
